import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const stats = [
  { value: 1200, suffix: "+", label: "Patients supported" },
  { value: 45, suffix: "", label: "Free community camps" },
  { value: 60, suffix: "+", label: "Special needs children helped" },
  { value: 8, suffix: "", label: "Years of service" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1800;
    const startTime = performance.now();
    const step = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(eased * value));
      if (progress < 1) requestAnimationFrame(step);
      else setDisplay(value);
    };
    requestAnimationFrame(step);
  }, [inView, value]);

  return <span ref={ref}>{display}{suffix}</span>;
};

export const ImpactStats = () => (
  <section className="bg-primary text-primary-foreground py-20 px-5 md:px-10">
    <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-10">
      {stats.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.1, duration: 0.6 }}
          data-testid={`impact-stat-${i}`}
        >
          <p className="font-heading text-4xl md:text-6xl text-accent">
            <Counter value={s.value} suffix={s.suffix} />
          </p>
          <p className="text-primary-foreground/70 text-sm mt-2">{s.label}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
